import React from 'react'
import ReactDOM from 'react-dom'

import LoadingOutlined from '@ant-design/icons/LoadingOutlined'

const LOADING_CONTAINER = 'x-fullpage-loading-container'

const show = () => {
  const loading = document.getElementById(LOADING_CONTAINER)

  if (loading) {
    loading.style.display = 'block'

    return
  }

  // Create a root
  const root = document.createElement('div')
  root.setAttribute('id', LOADING_CONTAINER)

  // Append root to body
  document.body.appendChild(root)

  // Render dialog component inside that div
  ReactDOM.render(
    <div
      style={{
        position: 'fixed',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
        }}
      >
        <LoadingOutlined style={{ fontSize: 50, color: '#5badfa' }} />
      </div>
    </div>,
    root
  )
}

const hide = () => {
  const loading = document.getElementById(LOADING_CONTAINER)

  if (loading) {
    loading.style.display = 'none'
  }
}

export default {
  show,
  hide,
}
